import { render } from "./webHeaderDesktop.vue?vue&type=template&id=385ed440&scoped=true&ts=true"
import script from "./webHeaderDesktop.vue?vue&type=script&lang=ts"
export * from "./webHeaderDesktop.vue?vue&type=script&lang=ts"

import "./webHeaderDesktop.vue?vue&type=style&index=0&id=385ed440&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385ed440"],['__file',"src/components/layout/webHeaderDesktop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "385ed440"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('385ed440', __exports__)) {
    api.reload('385ed440', __exports__)
  }
  
  module.hot.accept("./webHeaderDesktop.vue?vue&type=template&id=385ed440&scoped=true&ts=true", () => {
    api.rerender('385ed440', render)
  })

}


export default __exports__